export default "__VITE_ASSET__DOq8YSyK__"